import { createSlice } from '@reduxjs/toolkit'
import { getMessage } from '@reduxjs/toolkit/dist/actionCreatorInvariantMiddleware'
import { IProduct } from '../../../app/types/product'

export interface SearchState {
  productMessage: string
  product: IProduct | null
}

const initialState: SearchState = {
  productMessage: '',
  product: null,
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setProductSearchData: (state, { payload }) => {
      state.product = payload.product
      return state
    },
    setProductSearchMessage: (state, { payload }) => {
      state.productMessage = payload.message
      return state
    },
    getSearchMessages: (state) => {
      return state
    },
  },
})

export const {
  setProductSearchMessage,
  getSearchMessages,
  setProductSearchData,
} = searchSlice.actions

export default searchSlice.reducer
